import {useOutlet} from 'reconnect.js';

function useGlobalOutlets() {
  useOutlet('config');
  useOutlet('locale');
  useOutlet('categories');
}

export default useGlobalOutlets;
